import { render, staticRenderFns } from "./CheckBox.vue?vue&type=template&id=37096818&scoped=true&"
import script from "./CheckBox.vue?vue&type=script&lang=ts&"
export * from "./CheckBox.vue?vue&type=script&lang=ts&"
import style0 from "./CheckBox.vue?vue&type=style&index=0&id=37096818&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37096818",
  null
  
)

export default component.exports